export type CustomerTypeConfig = {
  label: string;
  color: string; // Ant Design tag color
  family: 'collectivites' | 'habitat' | 'autre';
};

const CUSTOMER_TYPE_CONFIG: Record<string, CustomerTypeConfig> = {
  // Types officiels (cf. api Customer.php enum)
  association: {
    label: 'Association',
    color: 'green',
    family: 'collectivites',
  },
  ccas: { label: 'CCAS', color: 'blue', family: 'collectivites' },
  department: {
    label: 'Département',
    color: 'purple',
    family: 'collectivites',
  },
  national: { label: 'National', color: 'orange', family: 'collectivites' },
  real_estate_player: { label: 'Bailleur', color: 'red', family: 'habitat' },

  // Types présents dans constants.ts mais hors enum API officielle.
  // On les mappe quand même au cas où des fixtures historiques en DB.
  assistance_provider: {
    label: 'Téléassisteur',
    color: 'cyan',
    family: 'autre',
  },
  clic: { label: 'CLIC', color: 'gold', family: 'collectivites' },
  social_center: {
    label: 'Centre social',
    color: 'lime',
    family: 'collectivites',
  },
};

export const ALL_CUSTOMER_TYPES_FOR_FILTER: { value: string; label: string }[] =
  Object.entries(CUSTOMER_TYPE_CONFIG).map(([value, config]) => ({
    value,
    label: config.label,
  }));

export const getCustomerTypeConfig = (
  type: string | undefined
): CustomerTypeConfig => {
  if (!type) return { label: 'Inconnu', color: 'default', family: 'autre' };
  return (
    CUSTOMER_TYPE_CONFIG[type] ?? {
      label: type,
      color: 'default',
      family: 'autre',
    }
  );
};
